import { combineReducers } from 'redux';

import authorsListReducer from './authorsListReducer';
import authorsHeaderReducer from './authorsHeaderReducer';
import authorsFilterReducer from './authorsFilterReducer';
import authorDetailReducer from './authorDetailReducer';

export default combineReducers({
  authors: authorsListReducer,
  authorsHeader: authorsHeaderReducer,
  authorsFilter: authorsFilterReducer,
  authorDetail: authorDetailReducer
});

